export default "__VITE_ASSET__Cvx9y$h1__"